import React from 'react';

import { truncateMidAddressInputValue } from '@/utils';

import BuildDetailsCopyBadge from '../components/BuildDetailsCopyBadge';
import BuildDetailsCwebExplorerLink from '../components/BuildDetailsCwebExplorerLink';
import BuildDetailsGrid, { BuildDetailsGridLabelValuePair } from '../components/BuildDetailsGrid';
import BuildDetailsNpmLink from '../components/BuildDetailsNpmLink';

export type L2ContractDetailsModule = {
  alias: string;
  version: string;
  contract_module: string;
  instance: {
    alias: string;
    instance_id: string;
    parameters: Record<string, unknown>;
  };
  pkg_mirror: {
    blake3: string;
    url: string;
  };
};

const BuildDetailsTokenInfoL2ContractModule: React.FC<{
  module: L2ContractDetailsModule;
}> = ({ module }) => {
  if (!module) return null;

  const { contract_module: contractTemplateId, alias, pkg_mirror: pkgMirror, version } = module;

  return (
    <>
      <li className="mt-2">
        <BuildDetailsGrid>
          <span className="text-muted-foreground">Template</span>
        </BuildDetailsGrid>
      </li>
      <li>
        <BuildDetailsGrid>
          <BuildDetailsGridLabelValuePair label="Alias" value={alias} />
        </BuildDetailsGrid>
      </li>
      <li>
        <BuildDetailsGrid>
          <BuildDetailsGridLabelValuePair label="Version" value={version} />
        </BuildDetailsGrid>
      </li>
      <li>
        <BuildDetailsGrid>
          <BuildDetailsGridLabelValuePair
            label="blake3"
            value={
              <BuildDetailsCopyBadge
                value={pkgMirror?.blake3 || ''}
                maskValue={(value) => truncateMidAddressInputValue(String(value), 24)}
              />
            }
          />
        </BuildDetailsGrid>
      </li>
      <li>
        <BuildDetailsGrid>
          <BuildDetailsGridLabelValuePair
            label="Package"
            value={<BuildDetailsNpmLink pkgMirror={pkgMirror?.url || ''} />}
          />
        </BuildDetailsGrid>
      </li>
      <li>
        <BuildDetailsGrid>
          <BuildDetailsGridLabelValuePair
            label="Contract Template"
            value={<BuildDetailsCwebExplorerLink id={contractTemplateId} />}
          />
        </BuildDetailsGrid>
      </li>
    </>
  );
};

export default BuildDetailsTokenInfoL2ContractModule;
